import React, { useState, useContext, memo, useEffect } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";
const Privacy = memo(() => {
  const { errors, setErrors } = useContext(Data);
  const [agree, setAgree] = useState(errors.privacy === null ? true : false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    agree
      ? setErrors({ ...errors, privacy: null })
      : setErrors({ ...errors, privacy: "*必須" });
  }, [agree]);

  const openModal = () => {
    setShow(() => true);
  };

  const closeModal = () => {
    setShow(() => false);
  };

  const onChange = () => {
    agree ? setAgree(false) : setAgree(true);
  };

  return (
    <>
      <div className={styles.privacyCheck}>
        <input
          type="checkbox"
          checked={agree ? true : false}
          onChange={onChange}
        />
        <p>
          <a onClick={openModal}>個人情報の取り扱い</a>
          <br className="sp" />
          にご同意の上、送信ください。
        </p>
      </div>

      <div
        className={styles.privacyModal}
        style={
          show
            ? { opacity: 1, visibility: "visible" }
            : { opacity: 0, visibility: "hidden" }
        }
      >
        <span onClick={closeModal}></span>
        <div>
          <h3 className="bold">個人情報の取り扱いに関して</h3>
          <p>
            NOYESは、お客様よりお預かりした個人情報の取り扱いについて、下記の通りお約束いたします。
          </p>
          <dl>
            <dt className="bold">1.個人情報の利用について</dt>
            <dd>
              NOYESは、お客様よりご提示いただきました個人情報を、お客様へ通したサービス利用目的の達成に必要な範囲内で、利用いたします。
            </dd>
            <dt className="bold">2.個人情報の第三者提供について</dt>
            <dd>
              NOYESは、個人情報保護法等の法令に定めのある場合を除き、個人情報をあらかじめご本人の同意を得ることなく、第三者に提供いたしません。
            </dd>
            <dt className="bold">3.個人情報の開示等について</dt>
            <dd>
              個人情報の開示、変更、削除の求めがあった場合には、お客様ご本人であることをご確認させていただいたうえで、すみやかに対応いたします。
            </dd>
            <span>以上</span>
          </dl>
          <a onClick={closeModal}>閉じる</a>
        </div>
      </div>
    </>
  );
});
export default Privacy;
